import React, {Component} from 'react';
import {Modal,Button,ButtonToolbar,Col,FormGroup,Form,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import DatePicker from './DatePicker'
import Moment from 'moment'

const TODAY = Moment().format('L').replace(Moment().format('YYYY'), (Moment().format('YYYY')*1) + 543);
class DatePickerModal extends Component {

    constructor(...args) {
        super(...args)
        this.state = {date:this.props.date}
    }

    onDateChange(e) {
        this.setState({date:e})
    }

    onConfirmClick() {
        this.props.onConfirm(this.state.date)
    }

    renderConfirmButton(){
      return(
          <ButtonToolbar className='pull-right'>
            <Button onClick={this.onConfirmClick.bind(this)} bsStyle='primary' style={{minWidth:'80px'}}><FontAwesome name='thumbs-o-up'/>&nbsp;OK</Button>
            <Button onClick={this.props.onHide}  style={{minWidth:'80px'}}><FontAwesome name='close'/>&nbsp;ยกเลิก</Button>
          </ButtonToolbar>
        )
      
    }

    render(){
      let {date} = this.state
      let {show} = this.props
      return (
        <Modal show={show} onHide={this.props.onHide} dialogClassName="alert-popup-dialog">
          <Modal.Header>
            เลือกเวลา
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
                <FormGroup controlId="formHorizontalEmail">
                    <Col componentClass={ControlLabel} sm={2}>
                        เลือกเวลา
                    </Col>
                    <Col sm={7}>
                    <DatePicker
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={date}
                        onChange={this.onDateChange.bind(this)}
                        maxWidth={'100%'}
                        />
                    </Col>
                </FormGroup>
            </Form>    
          </Modal.Body>
          <Modal.Footer>
            {this.renderConfirmButton()}
          </Modal.Footer>
        </Modal>
      )
    }
}


DatePickerModal.defaultProps = {
    date: TODAY
}

export default DatePickerModal



// WEBPACK FOOTER //
// ./src/component/element/DatePickerModal.js